module.exports = __webpack_public_path__ + "static/media/29BDOS9.01606527.jpg";